module.exports = __webpack_public_path__ + "img/6_b.23a858a6.jpg";